import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Settings, LogOut, Menu, ChevronDown } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Header({ onMenuClick }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    toast.success('Çıkış yapıldı');
    navigate('/login');
  };

  return (
    <header className="px-4 py-3 flex items-center justify-between lg:hidden" style={{ backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
      <button onClick={onMenuClick} className="p-2 rounded-lg transition-colors" style={{ color: 'var(--text-secondary)', backgroundColor: 'transparent' }}>
        <Menu className="w-5 h-5" />
      </button>

       <div className="relative">
         <button 
           onClick={() => setDropdownOpen(!dropdownOpen)} 
           className="flex items-center gap-2 px-3 py-2 rounded-lg transition-colors"
           style={{ color: 'var(--text)' }}
         >
           <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
             {user?.full_name?.[0]?.toUpperCase() || 'K'}
           </div>
           <ChevronDown className="w-4 h-4" style={{ color: 'var(--text-muted)' }} />
         </button>

         {dropdownOpen && (
           <>
             <div className="fixed inset-0 z-10" onClick={() => setDropdownOpen(false)} />
             <div className="absolute right-0 mt-2 w-44 rounded-lg shadow-lg z-20" style={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)' }}>
               <button 
                 onClick={() => { navigate('/settings'); setDropdownOpen(false); }} 
                 className="w-full text-left px-4 py-2.5 text-sm flex items-center gap-3"
                 style={{ color: 'var(--text)', borderBottom: '1px solid var(--border)' }}
               >
                 <Settings className="w-4 h-4" style={{ color: 'var(--text-secondary)' }} />
                 Ayarlar
               </button>
               <button 
                 onClick={handleLogout} 
                 className="w-full text-left px-4 py-2.5 text-sm flex items-center gap-3"
                 style={{ color: 'rgb(220, 38, 38)' }}
               >
                 <LogOut className="w-4 h-4" />
                 Çıkış Yap
               </button>
             </div>
           </>
         )}
       </div>
    </header>
  );
}
